import { equals } from 'ramda';

import { type TCoordinate } from '@/packages/api-models/common/json_query';

import {
  type GeoTag,
  type GeoTagType,
  type IDistanceGeoTag,
  type IPolygonGeoTag,
  type ISimpleGeoTag,
  type IUndergroundGeoTag,
} from '@/microfrontends/filters/shared/types/geoTags';

export const coordsNumberToString = (coord: YMaps.TCoord): TCoordinate => [String(coord[0]), String(coord[1])];

export const coordsArrayNumberToString = (coords: YMaps.TCoord[]): TCoordinate[] =>
  coords.map(coord => [String(coord[0]), String(coord[1])] as TCoordinate);

export const coordsIsEqual = (coords1: TCoordinate[], coords2: TCoordinate[]): boolean =>
  equals(coords1.concat().sort(), coords2.concat().sort());

export const circlesAreEqual = (
  circle1: { radius: number; center: TCoordinate },
  circle2: { radius: number; center: TCoordinate },
): boolean =>
  circle1.radius === circle2.radius &&
  circle1.center[0] === circle2.center[0] &&
  circle1.center[1] === circle2.center[1];

export function getTagComparator(type: GeoTagType): (tag1: GeoTag, tag2: GeoTag) => boolean {
  switch (type) {
    case 'distance':
      return distanceTagComparator;
    case 'polygon':
      return polygonTagComparator;
    default:
      return idTagComparator;
  }
}

function distanceTagComparator(tag1: IDistanceGeoTag, tag2: IDistanceGeoTag): boolean {
  return circlesAreEqual(tag1, tag2);
}

function polygonTagComparator(tag1: IPolygonGeoTag, tag2: IPolygonGeoTag): boolean {
  return coordsIsEqual(tag1.coordinates, tag2.coordinates);
}

function idTagComparator(tag1: ISimpleGeoTag | IUndergroundGeoTag, tag2: ISimpleGeoTag | IUndergroundGeoTag): boolean {
  return tag1.id === tag2.id;
}
